"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const monaco = __importStar(require("monaco-editor"));
const append_empty_line_1 = require("./append-empty-line");
const monaco_line_alter_scss_1 = __importDefault(require("./styles/monaco-line-alter.scss"));
function showLineAlter(editor) {
    const model = editor.getModel();
    if (!model) {
        throw new Error('Cannot get model');
    }
    editor.updateOptions({
        selectOnLineNumbers: false
    });
    // TODO: dispose
    editor.deltaDecorations([], [
        {
            range: new monaco.Range(1, 1, 100000, 1),
            options: {
                isWholeLine: true,
                marginClassName: monaco_line_alter_scss_1.default.widget
            }
        }
    ]);
    let previous = [];
    const move = (lineNumber) => {
        const len = model.getLineLength(lineNumber);
        previous = editor.deltaDecorations(previous, [
            {
                range: new monaco.Range(lineNumber, 1, lineNumber, 1 + len),
                options: {
                    isWholeLine: true,
                    className: monaco_line_alter_scss_1.default.line
                }
            }
        ]);
    };
    const hide = () => {
        editor.deltaDecorations(previous, []);
        previous = [];
    };
    let hold = null;
    editor.onMouseDown(e => {
        const { element, range } = e.target;
        if (!element || !element.classList.contains(monaco_line_alter_scss_1.default.widget))
            return;
        if (!range)
            return;
        hold = range;
        move(hold.startLineNumber);
    });
    editor.onMouseUp(() => {
        hold = null;
        hide();
    });
    let taskId = 0;
    editor.onMouseMove(e => {
        if (!hold)
            return;
        const { element, range } = e.target;
        if (!element || !element.classList.contains(monaco_line_alter_scss_1.default.widget))
            return;
        if (!range)
            return;
        const direction = range.startLineNumber - hold.startLineNumber;
        if (Math.abs(direction) !== 1)
            return;
        window.cancelIdleCallback(taskId);
        taskId = window.requestIdleCallback(() => {
            if (!hold)
                return;
            const holdText = model.getValueInRange(hold);
            const replaceText = model.getValueInRange(range);
            const acrossLine = range.startLineNumber + direction;
            // 入れ替える行とその向こうの行のインデントのうち、大きい方に合わせる
            const spaces = model
                .getFullModelRange()
                .containsPosition(new monaco.Position(acrossLine, 1))
                ? Math.max(append_empty_line_1.indent(replaceText), append_empty_line_1.indent(model.getLineContent(acrossLine)))
                : append_empty_line_1.indent(replaceText);
            const indentText = ' '.repeat(spaces) + holdText.trimLeft();
            // swap line
            model.pushEditOperations([], [
                {
                    forceMoveMarkers: false,
                    range,
                    text: indentText
                },
                {
                    forceMoveMarkers: false,
                    range: hold,
                    text: replaceText
                }
            ], () => null);
            hold = new monaco.Range(range.startLineNumber, 1, range.startLineNumber, 1 + indentText.length);
            move(range.startLineNumber);
        }, { timeout: 1000 });
    });
}
exports.showLineAlter = showLineAlter;
